/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import { WHITE, BLUE } from '../../../theme/colors'
import Button from 'antd/lib/button'

interface DivProps {
  secondary?: boolean
  showMenu?: boolean
  isExternal?: boolean
}

export const Container = styled.div`
  height: 100%;
  overflow-y: scroll;
`

export const Arrow = styled(Icon)`
  color: #5f6062;
  font-size: 16px;
`

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 32px;
  background-color: #eff2f4;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`
interface PageProps {
  isFirstTab: boolean
}

export const TextColors = styled.div`
  color: #5f6062;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  margin-left: ${({ isFirstTab }: PageProps) => (isFirstTab ? '0' : '6px')};
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 16px;
  line-height: 22px;
  margin: 0px 8px;
`

export const StitchingList = styled.div`
  padding-top: 12px;
`

export const TabsContainer = styled.div`
  overflow-y: scroll;
  overflow: visible;
  margin-top: 16px;
  position: relative;
  .ant-tabs-content {
    height: auto !important;
  }
  .ant-tabs-top {
    margin-left: 10px;
  }
  & .ant-tabs-nav-wrap {
    display: flex !important;
    justify-content: center !important;
    background-color: ${WHITE} !important;
    height: 42px !important;
  } 

  & .ant-tabs-ink-bar {
    display: none !important;
    background-color: #626262 !important;
    bottom: -5px !important;
  }

  & .ant-tabs-nav .ant-tabs-tab {
    color: #616161 !important;
    padding: 8px 16px;
    margin: 0;
  }

  & .ant-tabs-nav .ant-tabs-tab-active {
    font-weight: 600 !important;
  }
  .ant-tabs-nav-wrap {
    justify-content: flex-start !important;
    padding-left: 16px !important;
  }
  .ant-tabs-tab {
    transition: all .15s;
  }
  ${({ showMenu }: DivProps) => showMenu ? `
    & .ant-tabs-ink-bar {
      display: block !important;
    }
    .ant-tabs-nav-container {
      border-bottom: 1px solid #DCDCDC;
    }
    .ant-tabs-nav-animated {
      padding-right: 4px;
    }
  ` : ''}
`

export const TabTitle = styled.div`
  font-size: 13px;
  ${({ secondary, isExternal }: DivProps) => secondary ? `
    font-weight: normal;
    ${isExternal ? `
      border: 1px solid darkgray;
      padding-inline: 10px;
      color: dimgray;
    ` : ''}
  ` : ''}
`

export const CloseButton = styled(Icon)`
  position: absolute;
  top: 2px;
  right: -12px;
  background: white;
  color: #d27979;
  border-radius: 10px;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #d27979;
    color: white;
  }
`

export const GoBack = styled.div`
  border: 1px solid ${BLUE};
  color: ${BLUE};
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 12px;
  margin-top: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLUE};
    color: ${WHITE};
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  padding: 1px 32px 0 32px;
  border: 1px solid #453f40;
  height: 28px;
  color: #453f40;
  &:hover {
    cursor: pointer;
    background: #3c3637;
    color: ${WHITE};
    border-color: #453f40;
  }
`

export const ColorsIcon = styled.img`
  width: 16px;
  margin-right: 10px;
  margin-top: -2px;
`

export const SavePalette = styled.div`
  position: absolute;
  right: 9px;
  z-index: 2;
  top: 24px;
  border: 1px solid #453f40;
  color: #3c3637;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #3c3637;
    color: ${WHITE};
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ColorsTab/styledComponents.tsx